import React, {useContext, useState} from "react";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import IconCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import EditOrgWithDaData from "../../../../components/Modals/EditOrgWithDaData";
import OrgPage from "../../../../components/OrgPage";
import DaDataModal4 from "../../../../components/Modals/DaDataModal4";
import {AuthContext} from "../../../../context/AuthContext";

function Organizations_organization(props) {
    const {token} = useContext(AuthContext)
    const url = `/api/v2/systemManagers/${token.userId}/organizations?`;

    const baseURL = process.env.REACT_APP_BASE_URL
    const [modal, showModal] = useState()
    const [editModal, showEditModal] = useState()
    const [modalId, setModalId] = useState()
    const [refresh, setRefresh] = useState(false)
    const {REACT_APP_URL_PREFIX} = process.env

    const editOrg = (data) => {
        setModalId(data)
        showEditModal(true)
    }

    const closeHandler = () => {
        showModal(false)
        showEditModal(false)
        setRefresh(!refresh)
    }


    const linkCellToHistory = (props) => {
        const url = REACT_APP_URL_PREFIX + `/counterAgents/organizations/${props.idArr[0]}/${props.idArr[1]}/${props.cellContent}/history`;
        return (
            <LinkCell3
                linkRoute={url}
                linkTitle={props.cellContent}
                editClick={(e) => editOrg(props.idArr[0])}
            />
        );
    };

    const linkCellToCalndar = (props) => {
        const orgId = props.idArr[0];
        const orgName = props.cellContent;
        return (
            <IconCell
                iconName={"calendar"}
                to={REACT_APP_URL_PREFIX + `/calendar/organization/${orgId}/${orgName}`}
            />
        );
    };

    return (
        <>
            {editModal
                ? <EditOrgWithDaData id={modalId}
                                     closeHandler={closeHandler}
                                     url={"/api/v1/verificationCenter/medicalCenters?"}/> : ''}

            {modal
                ? <DaDataModal4 closeHandler={closeHandler} role={props.roleIs}
                                url={props.addOrgAPI}/>
                : ''}


            <OrgPage
                refresh={refresh}
                firstRow={[
                    {title: "Название", id: "org_name",},
                    {title: "Каленадрь", id: ""},
                    {title: "Количество пациентов", id: "",},  // Сортировка не добавлена
                    {title: "Вызов", id: "",}  // Сортировка не добавлена
                ]}
                haveToShow={[
                    {
                        id: "name",
                        idArr: ["org_id", "verification_id"],
                        type: "wrapperCell",
                        typeData: {cell: linkCellToHistory},
                    },
                    {
                        id: "name",
                        idArr: ["org_id"],
                        type: "wrapperCell",
                        typeData: {cell: linkCellToCalndar},
                    },
                    {id: "patients_count"},
                    {id: "invite_count"},
                ]}
                url={`${baseURL}${url}`}

                breadCrumbsItems={[
                    {title: 'Контрагенты', },
                    {title: 'Организации', actual: true},

                ]}
                addOrg={{
                    org: true,
                    onClick() {
                        showModal(!modal)
                    }
                }}

                filterBarButtons={{
                    downloadTemplate: {
                        show: false,
                        url: '/'
                    }
                }}
                filterFieldsConf={{
                    name: true,
                    inn: true,
                    date: true,
                    period: true,
                }}
            />
        </>
    );
}

export default Organizations_organization;


